export default [
    {
        path: '/laporan',
        redirect: '/laporan',
        name: 'laporan',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'laporanIndex',
                component: () => import('@/views/laporan/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'laporan',
                    pageTitle: 'Laporan',
                    breadcrumb: [
                        {
                            text: 'Laporan',
                            active: true,
                        },
                    ],
                },
            },
        ]
    }
]